import { render, staticRenderFns } from "./BackdropTrailer.vue?vue&type=template&id=f7a2ada0&scoped=true"
import script from "./BackdropTrailer.vue?vue&type=script&lang=ts"
export * from "./BackdropTrailer.vue?vue&type=script&lang=ts"
import style0 from "./BackdropTrailer.vue?vue&type=style&index=0&id=f7a2ada0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a2ada0",
  null
  
)

export default component.exports